import { useEffect } from "react";
import type { BrandDefinition } from "@school-sales-ai/shared";
import { brandMarkSrc } from "@/lib/brand";

/**
 * Keeps the browser tab — title and favicon — on the CLIENT's brand.
 *
 * The static HTML already gets the tab right per DOMAIN (`index.html` for
 * ScholaOps, `index-loxago.html` for Loxago, picked by a host rewrite in
 * `vercel.json`). That is the correct answer for the anonymous screens, and the
 * wrong one for a Loxago user who logged in through app.scholaops.ai — the same
 * "wrong door is not an error" rule the sidebar follows (CLAUDE.md §6.13).
 *
 * `null` means "not known yet" and leaves the tab alone: overwriting the
 * per-domain HTML with the default brand while `/crm/branding` is still in
 * flight would flash the wrong favicon on every page load of the other brand.
 */
export function useBrandDocumentHead(brand: BrandDefinition | null): void {
  useEffect(() => {
    if (!brand) return;
    document.title = `${brand.name} - CRM`;
    const icon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (icon) icon.href = brandMarkSrc(brand);
  }, [brand]);
}
